import { useTranslation } from "react-i18next";
import { LanguageMenu, LanguageMenuItem } from "suomifi-ui-components";

export default function LanguageSwitcher() {
  const { i18n, t } = useTranslation("common");

  const nykyinen = i18n.language === "en" ? "EN" : "FI";

  return (
    <LanguageMenu buttonText={nykyinen} aria-label={t("kieli.valitse")}>
      <LanguageMenuItem
        lang="fi"
        onSelect={() => {
          void i18n.changeLanguage("fi");
        }}
        selected={i18n.language === "fi"}
      >
        Suomeksi (FI)
      </LanguageMenuItem>
      <LanguageMenuItem
        lang="en"
        onSelect={() => {
          void i18n.changeLanguage("en");
        }}
        selected={i18n.language === "en"}
      >
        In English (EN)
      </LanguageMenuItem>
    </LanguageMenu>
  );
}
